import React, { useEffect, useState } from 'react';
import axios from 'axios';
import "ag-grid-enterprise";
import { AgGridReact } from "ag-grid-react";
import "ag-grid-enterprise/styles/ag-grid.css";
import "ag-grid-enterprise/styles/ag-theme-alpine.css";

const AirlineCredsModal = ({ pan, onClose }) => {
  const [rowData, setRowData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');
  const [editModalVisible, setEditModalVisible] = useState(false);
  const [selectedRow, setSelectedRow] = useState(null);
  const [portalId, setPortalId] = useState('');
  const [portalPass, setPortalPass] = useState('');
  const [token, setToken] = useState(null);

  const columnDefs = [
    { headerName: "ID", field: "id", width: 300 },
    { headerName: "Airline Name", field: "airline_name", width: 200 },
    { headerName: "Portal ID", field: "portal_id", width: 150 },
    { headerName: "Portal Password", field: "portal_pass", width: 200 },
    { headerName: "Valid", field: "valid", width: 100, cellRenderer: params => (params.value ? "true" : "false") },
    { headerName: "Last Run", field: "last_ran", width: 150 },
    {
      headerName: "Action",
      field: "action",
      cellRenderer: (params) => (
        <button className='validate-btn' onClick={() => handleEditClick(params.data)}>Edit</button>
      ),
      width: 100,
    },
  ];

  useEffect(() => {
    const savedToken = sessionStorage.getItem('token');
    if (savedToken) {
      setToken(savedToken);
    }
    const fetchAirlineCreds = async () => {
      try {
        const response = await axios.get(`https://stage-apiplatform.finkraft.ai/api/meta/airlinecreds/${pan}`);
        setRowData(response.data);
        setLoading(false);
      } catch (error) {
        console.error("Error fetching airline creds:", error);
        setError("Failed to fetch data.");
        setLoading(false);
      }
    };

    fetchAirlineCreds();
  }, [pan]);

  const handleEditClick = (rowData) => {
    setSelectedRow(rowData);
    setPortalId(rowData.portal_id);
    setPortalPass(rowData.portal_pass);
    setEditModalVisible(true);
  };

  const handleUpdate = async () => {
    if (!selectedRow) return;

    try {
      await axios.put(`https://stage-apiplatform.finkraft.ai/api/meta/airlinecreds/${selectedRow.id}`, {
        portal_id: portalId,
        portal_pass: portalPass,
      },
      {
        headers: {
            'Authorization': `Bearer ${token}`
        }
      });
      setRowData((prevData) => prevData.map((row) => 
        row.id === selectedRow.id ? { ...row, portal_id: portalId, portal_pass: portalPass } : row
      ));
      setEditModalVisible(false);
      setSelectedRow(null);
    } catch (error) {
      console.error("Error updating airline creds:", error);
      setError("Failed to update data.");
    }
  };



  return (
    <div className="airline-modal-overlay">
      <div className="airline-modal-content">
        <h2>Airline Credentials for PAN: {pan}</h2>
        <button onClick={onClose}>Close</button>
        <div className="ag-theme-alpine" style={{ height: '400px', width: '100%' }}>
          <AgGridReact
            rowData={rowData}
            columnDefs={columnDefs}
          />
        </div>

        {editModalVisible && (
          <div className="edit-modal">
            <h3>Edit Airline Credentials</h3>
            <div>
              <label>Portal ID:</label>
              <input 
                type="text" 
                value={portalId} 
                onChange={(e) => setPortalId(e.target.value)} 
              />
            </div>
            <div>
              <label>Portal Password:</label>
              <input 
                value={portalPass} 
                onChange={(e) => setPortalPass(e.target.value)} 
              />
            </div>
            <button onClick={handleUpdate}>Update</button>
            <button onClick={() => setEditModalVisible(false)}>Cancel</button>
          </div>
        )}
      </div>
    </div>
  );
};

export default AirlineCredsModal;
